import React from 'react';
import FooterLessLayout from '../../components/Layout/FooterLessLayout';
import Search from './Search';
import fetch from '../../core/fetch';

import { searchListing } from '../../actions/searchListing';
import { setPersonalizedValues } from '../../actions/personalized';

import { showLoading, hideLoading } from 'react-redux-loading-bar';
import moment from 'moment';
import messages from '../../locale/messages';
import { buildLocationValue, resolveGuestFilter } from '../../helpers/homeSearch';

const title = 'Search';

export default async function action({ params, store, query, intl, locale }) {

  const title = intl && intl.formatMessage
    ? intl.formatMessage(messages.search)
    : 'Buscar experiencias rurales';

  store.dispatch(showLoading());

  // Fetch Search Settings
  const searchQuery = `
    {
      getSearchSettings {
        minPrice
        maxPrice
        priceRangeCurrency
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: searchQuery,
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();
  const searchSettings = data && data.getSearchSettings
    ? data.getSearchSettings
    : {
      minPrice: 10,
      maxPrice: 10000,
      priceRangeCurrency: 'USD',
    };



  // From Redux Store
  const geographyData = store.getState().personalized.geography;
  const personCapacityData = store.getState().personalized.personCapacity;
  const startDateData = store.getState().personalized.startDate;
  const endDateData = store.getState().personalized.endDate;
  let geoType = store.getState().personalized.geoType;
  let lat = store.getState().personalized.lat;
  let lng = store.getState().personalized.lng;
  let sw_lat = store.getState().personalized.sw_lat;
  let sw_lng = store.getState().personalized.sw_lng;
  let ne_lat = store.getState().personalized.ne_lat;
  let ne_lng = store.getState().personalized.ne_lng;
  let personCapacity, dates, geography, currentPage = 1, location;
  const listingType = query.mode === 'experiences' ? 'experience' : 'accommodation';
  const state = String(query.state || '').trim() || null;
  const city = String(query.city || '').trim() || null;
  const country = String(query.country || (state || city ? 'CO' : '')).trim() || null;
  let initialFilter = {};
  initialFilter.listingType = listingType;
  Object.assign(initialFilter, { country, state, city });
  let fixedHeader = 'searchFixedHeader'


  if (country || state || city) {
    // Dropdown choices are exact administrative filters; geocoding must not widen them.
    geography = JSON.stringify({ country, administrative_area_level_1_long: state, locality: city });
    geoType = city ? 'city' : state ? 'state' : 'country';
    lat = lng = sw_lat = sw_lng = ne_lat = ne_lng = null;
    location = query.address || buildLocationValue(city, state) || 'Colombia';
    Object.assign(initialFilter, { address: location, geography, geoType, lat, lng, sw_lat, sw_lng, ne_lat, ne_lng });
    store.dispatch(setPersonalizedValues({ name: 'location', value: location }));
  } else if ("address" in query && encodeURI(query.address)) {
    let latAndLngQuery = `
          query ($address: String) {
            GetAddressComponents (address:$address) {
              addressComponents
              lat
              lng
              geoType
              sw_lat 
              sw_lng 
              ne_lat 
              ne_lng
            }
          }
        `;
    const locationResp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: latAndLngQuery,
        variables: { address: query.address }
      }),
      credentials: 'include',
    });

    const { data } = await locationResp.json();
    if (data && data.GetAddressComponents) {
      initialFilter["address"] = query.address;
      initialFilter["geography"] = data.GetAddressComponents.addressComponents;
      initialFilter["lat"] = data.GetAddressComponents.lat;
      initialFilter["lng"] = data.GetAddressComponents.lng;
      initialFilter["sw_lat"] = data.GetAddressComponents.sw_lat;
      initialFilter["sw_lng"] = data.GetAddressComponents.sw_lng;
      initialFilter["ne_lat"] = data.GetAddressComponents.ne_lat;
      initialFilter["ne_lng"] = data.GetAddressComponents.ne_lng;
      geography = data.GetAddressComponents.addressComponents;
      geoType = data.GetAddressComponents.geoType;
      lat = data.GetAddressComponents.lat;
      lng = data.GetAddressComponents.lng;
      sw_lat = data.GetAddressComponents.sw_lat,
        sw_lng = data.GetAddressComponents.sw_lng,
        ne_lat = data.GetAddressComponents.ne_lat,
        ne_lng = data.GetAddressComponents.ne_lng;
      location = query.address;
      store.dispatch(setPersonalizedValues({ name: 'location', value: query.address }));
    }
  } else {
    lat = null;
    lng = null;
    sw_lat = null;
    sw_lng = null;
    ne_lat = null;
    ne_lng = null;
    // If no location passed
    ['geography', 'geoType', 'location', 'lat', 'lng', 'sw_lat', 'sw_lng', 'ne_lat', 'ne_lng', 'chosen'].map((name) => {
      store.dispatch(setPersonalizedValues({ name, value: null }));
    })
  }
  // }

  // PersonCapacity
  personCapacity = resolveGuestFilter(query, personCapacityData);
  if (personCapacity) {
    initialFilter["personCapacity"] = personCapacity;
  }

  store.dispatch(setPersonalizedValues({ name: 'personCapacity', value: personCapacity }));

  const hasQueryDates = "startdate" in query && "enddate" in query && query.startdate && query.enddate;
  const isCatalogEntry = Object.prototype.hasOwnProperty.call(query, 'mode');
  if (!hasQueryDates && !isCatalogEntry && startDateData != undefined && startDateData != null && endDateData != undefined && endDateData != null) {
    dates = `'${startDateData}' AND '${endDateData}'`;
  } else {
    let today = moment(new Date()).format("YYYY-MM-DD");
    let startDate = moment(query.startdate).format("YYYY-MM-DD");
    let endDate = moment(query.enddate).format("YYYY-MM-DD");
    let checkValidDate = false;
    if ((startDate < today) || endDate < today) {
      checkValidDate = true;
    } else if (startDate == endDate) {
      checkValidDate = true;
    } else if (startDate > endDate) {
      checkValidDate = true;
    } else if ((moment(startDate).isValid() == false) || (moment(endDate).isValid() == false)) {
      checkValidDate = true;
    }

    if (checkValidDate) {
      query.startdate = '';
      query.enddate = '';
    }

  }
  
  if ("startdate" in query && "enddate" in query && query.startdate && query.enddate) {
    initialFilter["startDate"] = query.startdate;
    initialFilter["endDate"] = query.enddate;
    dates = `'${query.startdate}' AND '${query.enddate}'`;
    store.dispatch(setPersonalizedValues({ name: 'startDate', value: query.startdate }));
    store.dispatch(setPersonalizedValues({ name: 'endDate', value: query.enddate }));
  } else if (isCatalogEntry) {
    store.dispatch(setPersonalizedValues({ name: 'startDate', value: null }));
    store.dispatch(setPersonalizedValues({ name: 'endDate', value: null }));
  }
  
  // Default Map Show
  await store.dispatch(setPersonalizedValues({ name: 'showMap', value: true }));

  await store.dispatch(searchListing({ personCapacity, dates, geography, currentPage, geoType, lat, lng, sw_lat, sw_lng, ne_lat, ne_lng, location, listingType, country, state, city }))

  return {
    title,
    component: <FooterLessLayout page={'search'} fixedHeader={fixedHeader}><Search
      initialFilter={initialFilter}
      searchSettings={searchSettings}
    />
    </FooterLessLayout>,
  };
}
